import { memo } from 'react';
import { Skeleton } from '@/components/ui/skeleton';
import { PageContainer } from '@/components/templates/PageContainer';
import { ProfileCardSkeleton } from '@/components/molecules/skeletons';

const RightSidebarSkeleton = (
  <div className="sticky top-20 w-40 h-[600px]">
    <Skeleton className="h-full w-full rounded-xl" />
  </div>
);

export const ProfilePageSkeleton = memo(() => {
  return (
    <PageContainer rightSidebar={RightSidebarSkeleton}>
      <div className="space-y-6">
        <ProfileCardSkeleton />
        {/* Tab placeholder */}
        <div className="bg-card border border-border rounded-xl shadow-none p-4">
          <div className="max-w-md grid grid-cols-2 gap-2 mb-4">
            <Skeleton className="h-9 rounded-md" />
            <Skeleton className="h-9 rounded-md" />
          </div>
          <Skeleton className="h-48 w-full rounded-md" />
        </div>
      </div>
    </PageContainer>
  );
});

ProfilePageSkeleton.displayName = 'ProfilePageSkeleton';
